import { selectDate, inputInfo} from '../../types/Reievespf002'

type makeupProps = {
    selectedDate: string;
    joinedDate: string;
    clubName: string;
    memo: string;
}
/**
 * メークアップ登録の入力値チェック
 */
export function inputValidate(makeupProps: makeupProps,  fileProps: File | undefined | null, dateList: selectDate[]){

    const message: string[] = [];
        
        const select = makeupProps.selectedDate
        const joinedDate = makeupProps.joinedDate;
        const clubName = makeupProps.clubName;
        const memo = makeupProps.memo;

        const fileName = fileProps?.name;
        const filetype = fileProps?.type;
        
        //  出席にする日付の値チェック
        if(select == '' || select == 'NOT-SELECT'){
            message.push('出席にする日付を選択してください。')
        }else if(!checkSelectDate(select, dateList)){
            message.push('出席にする日付の値が不正です。')
        }
        //  参加した日付の値チェック
        if(joinedDate === ''){
            message.push('参加した日付を入力してください。')
        }

        //  参加したクラブ名の値チェック
        if(clubName === ''){
            message.push('参加したクラブ名を入力してください。')
        }else if(clubName.length > 50){
            message.push('参加したクラブ名は50文字以下で入力してください。')
        }


        //  メークアップ証明書の値チェック
        if(!fileProps){
            message.push('メークアップ証明書を選択してください。')
        }else{
            if(filetype && !checkFileType(filetype)){
                message.push('メークアップ証明書はJPG,JPEG,PNGのいずれかで選択してください。')
            }

            if(fileName && fileName.length > 50){
                message.push('メークアップ証明書の添付ファイル名は拡張子含め100文字以下にしてください。')
            }
        }

        //  備考欄のチェック
        if(memo.length > 1000){
            message.push('備考欄は1000文字以下で入力してください。')
        }
        return message

}

/**
     * 出席にする日付の不正値チェック
     * @param select    選択した日付(YYYY年MM月DD日)
     *        dateList  DBから取得した日付リスト(YYYY/MM/DD)
     */
function  checkSelectDate(select: string, dateList: selectDate[]){
    //const formatSelectDate = select.replace('年', '/').replace('月', '/').replace('日', '')
    
    for(var i=0; i<dateList.length; i++){
        const listDate = new Date(dateList[i].date)
        const formatDay = listDate.toLocaleDateString("ja-JP", {year: "numeric", month: "short", day:"numeric"})
        if(formatDay === select){
            return true;
        }
    }
    return false

}

/**
 * ファイルの拡張子チェック
 */
function checkFileType(filetype: string){
    if(filetype === 'image/jpeg' || filetype === 'image/png'){
        return true
    }
    return false
}